var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('iframe',{staticClass:"strategio-iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40def895","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/show-helpdesk.vue
// module id = null
// module chunks = 